import { useNavigate } from 'react-router';
import { useContextSelector as useCS } from 'use-context-selector';
import { ApiMethodsEnum } from 'infrastructure/enums/ApiMethodsEnum';
import { storageService } from 'infrastructure/services/StorageService';
import { RolesEnum } from 'infrastructure/enums/RolesEnum';
import { useRequest } from 'domain/core/hooks/useRequest';
import { TUpdate } from 'domain/types';
import {
  GlobalConfigContext,
  TGlobalConfigContextState,
} from 'domain/globalConfig/GlobalConfigContext';
import { globalConfigSelectors } from 'domain/globalConfig/selectors';
import { useEffect } from 'react';

export const useLoginWithEmail = (): any => {
  const navigate = useNavigate();
  const update: TUpdate<TGlobalConfigContextState> | undefined = useCS(
    GlobalConfigContext,
    globalConfigSelectors.update
  );

  const { data, isLoading, error, send } = useRequest({
    url: '/api/v1/auth/email/login',
    method: ApiMethodsEnum.Post,
    sendOnStart: false,
    body: {},
  });

  const login = (body: { email: string; password: string }) => {
    const { email, password } = body;
    if (email && password) {
      send({ ...body });
    }
  };

  useEffect(() => {
    if (!error && data?.token && data?.refreshToken) {
      storageService.setItem('accessToken', data?.token);
      storageService.setItem('refreshToken', data?.refreshToken);
      if (data?.user?.role?.id === 1) {
        storageService.removeItem('accessToken');
        storageService.removeItem('refreshToken');
        navigate('/auth/onboarding', { replace: true });
        return;
      }
      if (data?.user?.role?.name === RolesEnum.GUEST) {
        navigate('/auth/choose-your-role', { replace: true });
        return;
      }
      if (data?.user?.role?.name === RolesEnum.JOB_SEEKER) {
        if (update) update({ userData: data?.user, isReady: true });
        navigate('/profile/job-list', { replace: true });
      }
      if (data?.user?.role?.name === RolesEnum.RECRUITER) {
        if (update) update({ userData: data?.user, isReady: true });
        navigate('/candidates/candidates-list', { replace: true });
      }
    }
  }, [error, data]);

  return {
    isLoading,
    error,
    send: login,
  };
};
